import { createAction } from "@redux/actions/actionCreators";

const [useChangeKeywordFilter, changeKeywordFilter] = createAction<string>(
  "search/changeKeywordFilter"
);

export default useChangeKeywordFilter;
export { changeKeywordFilter };
